import Ability from 'ember-can/ability';
export { Ability };